module.exports = __webpack_public_path__ + "static/Puzzle-42ed110a2d5a8b5f11bbbb5ab63e4a20.svg";